import React, { Component } from "react";

import { connect } from "react-redux";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Filters from "../../../../components/Filter/filters";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ResourceList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      filtered: [],
      loading: true
    };

    this.filter = this.filter.bind(this);
    this.insertResource = this.insertResource.bind(this);
    this.deleteResources = this.deleteResources.bind(this);
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleResources();
  }

  insertResource() {
    this.props.history.push("/education/resource/create");
  }

  deleteResources(rows) {
    if (rows) {
      rows.forEach(id => {
        axios
          .post(
            `${URL.api}education/resource/delete/${id}`,
            {},
            {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            }
          )
          .then(
            resp => {
              this.handleResources();
            },
            () => {
              this.error(`Não foi possível apagar o recurso ${id}`);
            }
          );
      });
    }
  }

  filter(role = null, group = null, region = null, school = null) {
    this.setState({ filtered: null }, () => {
      this.setState(state => ({
        filtered: state.list.filter(
          region => !group || region.group_id === group
        )
      }));
    });
  }

  handleResources() {
    axios
      .get(`${URL.api}education/resource/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState(
            () => ({
              list: null
            }),
            () => {
              if (resp.data.data.length === 0) {
                this.setState(() => ({
                  list: [],
                  loading: false
                }));
              } else {
                this.setState(
                  () => ({
                    list: resp.data.data,
                    loading: false
                  }),
                  () => {
                    this.filter(
                      null,
                      this.props.general.active_roles.group_id,
                      null,
                      null
                    );
                    this.forceUpdate();
                  }
                );
              }
            }
          );
        } else {
          this.props.logout(this.props.user.token);
        }
      });
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            <Filters
              key={JSON.stringify(this.props.general.active_roles)}
              initial="group"
              type="hierarchy"
              group
              action={this.filter}
            />
            {this.state.filtered ? (
              <div id="list">
                <DataTable
                  list={this.state.filtered}
                  path="/education/resource/edit/"
                  title="Recursos"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "description", denomination: "Descrição" },
                    { name: "code", denomination: "Código Padronizado" }
                  ]}
                  insert
                  delete
                  insertAction={this.insertResource}
                  deleteAction={this.deleteResources}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceList);
